import printDayHeaderUrl from './printDayHeader.html';
class PrintDayHeaderCtrl {
  constructor(ShiftHeaderUtils) {
    'ngInject';

    Object.assign(this, { ShiftHeaderUtils });
  }

  $onInit() {
    this.hours = this.ShiftHeaderUtils.getFormattedHours(this.ShiftHeaderUtils.getProperHours());
  }
}

export default {
  templateUrl: printDayHeaderUrl,
  controller: PrintDayHeaderCtrl,
  controllerAs: 'ctrl',
  bindings: {
    date: '<',
  },
};
